module.exports = __webpack_public_path__ + "static/media/RefreshCode.d95564a7.png";